import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ElementLocale from 'element-ui/lib/locale';
import util from '@/util';
import { ruleMap } from './i18nRuleMap';

import zh_CN from './zh_CN';
import en_US from './en_US';
import fr_FR from './fr_FR';
import de_DE from './de_DE';
import it_IT from './it_IT';
import es_ES from './es_ES';
import ru_RU from './ru_RU';
import tr_TR from './tr_TR';
import pt_BR from './pt_BR';
import th_TH from './th_TH';
import es_MX from './es_MX';
import ja_JP from './ja_JP';
import pl_PL from './pl_PL';
import in_ID from './in_ID';
import my_MM from './my_MM';
import ar_SA from './ar_SA';
import vi_VN from './vi_VN';
import fa_IR from './fa_IR';
import en_MY from './en_MY';

const messages = {
  zh_CN,
  en_US,
  fr_FR,
  de_DE,
  it_IT,
  es_ES,
  ru_RU,
  tr_TR,
  pt_BR,
  th_TH,
  es_MX,
  ja_JP,
  pl_PL,
  in_ID,
  my_MM,
  ar_SA,
  vi_VN,
  fa_IR,
  en_MY,
};

Vue.use(VueI18n);

let locale = util.getURLSearchParam('lang') || util.getCookie('lang');

if (!locale || locale.length !== 5) {
  locale = 'zh_CN';
}

const i18n = new VueI18n({
  locale,
  messages,
  fallbackLocale: 'zh_CN',
  pluralizationRules: ruleMap,
});

ElementLocale.i18n((key, value) => i18n.t(key, value));

export default i18n;
